import { createStore } from "vuex";

// import 'es6-promise/auto';
import layout from "./modules/layout";
import menu from "./modules/menu";
// import chat from './modules/chat';
// import product from './modules/product';
// import email from './modules/email';
// import todo from './modules/todo';
// import firebase_todo from './modules/firebase_todo';
// import contact from './modules/contact';
// import jobs from './modules/jobs';
// import courses from './modules/courses';
// import common from './modules/common';
// import tags from './modules/tags';
// import calendar from './modules/calendar'
// import { alert } from './modules/alert';
// import { authentication } from './modules/authentication';
// import { users } from './modules/users';

export default createStore({
  state: {
    langIcon: "",
    langLangauge: "",
    isActive: false,
    judulHalaman: "",
    dataTrigger: "",
    moonshot: "",
    shouldTriggerFunction: false,
    shouldTriggerFunction1: false,
    shouldTriggerFunction2: false,
    shouldTriggerFunction3: false,
    shouldTriggerFunction4: false,
    shouldTriggerFunction5: false,
    shouldTriggerFunction6: false,
    shouldTriggerFunction7: false,
    shouldTriggerFunction8: false,
    shouldTriggerFunction9: false,
    shouldTriggerFunction10: false,
  },
  getters: {
    langIcon: (state) => {
      return state.langIcon;
    },
    langLangauge: (state) => {
      return state.langLangauge;
    },
    dataTrigger: (state) => state.dataTrigger,
    shouldTriggerFunction: (state) => state.shouldTriggerFunction,
    shouldTriggerFunction1: (state) => state.shouldTriggerFunction1,
    shouldTriggerFunction2: (state) => state.shouldTriggerFunction2,
    shouldTriggerFunction3: (state) => state.shouldTriggerFunction3,
    shouldTriggerFunction4: (state) => state.shouldTriggerFunction4,
    shouldTriggerFunction5: (state) => state.shouldTriggerFunction5,
    shouldTriggerFunction6: (state) => state.shouldTriggerFunction6,
    shouldTriggerFunction7: (state) => state.shouldTriggerFunction7,
    shouldTriggerFunction8: (state) => state.shouldTriggerFunction8,
    shouldTriggerFunction9: (state) => state.shouldTriggerFunction9,
    shouldTriggerFunction10: (state) => state.shouldTriggerFunction10,
  },
  mutations: {
    setTriggerFunction(state, value) {
      state.shouldTriggerFunction = value;
    },
    setTriggerFunction1(state, value) {
      state.shouldTriggerFunction1 = value;
    },
    setTriggerFunction2(state, value) {
      state.shouldTriggerFunction2 = value;
    },
    setTriggerFunction3(state, value) {
      state.shouldTriggerFunction3 = value;
    },
    setTriggerFunction4(state, value) {
      state.shouldTriggerFunction4 = value;
    },
    setTriggerFunction5(state, value) {
      state.shouldTriggerFunction5 = value;
    },
    setTriggerFunction6(state, value) {
      state.shouldTriggerFunction6 = value;
    },
    setTriggerFunction7(state, value) {
      state.shouldTriggerFunction7 = value;
    },
    setTriggerFunction8(state, value) {
      state.shouldTriggerFunction8 = value;
    },
    setTriggerFunction9(state, value) {
      state.shouldTriggerFunction9 = value;
    },
    setTriggerFunction10(state, value) {
      state.shouldTriggerFunction10 = value;
    },
    updateJudulHalaman(state, newValue) {
      state.judulHalaman = newValue;
    },

    setTrigger(state, newValue) {
      state.dataTrigger = newValue;
    },

    updatePageMoonshot(state, newValue) {
      state.moonshot = newValue;
    },

    changeLang(state, payload) {
      localStorage.setItem("currentLanguage", payload.id);
      localStorage.setItem("currentLanguageIcon", payload.icon);
      state.langIcon = payload.icon || "flag-icon-us";
      state.langLangauge = payload.id || "EN";
      // window.location.reload();
    },
    change(state) {
      state.isActive = !state.isActive;
    },
  },
  actions: {
    triggerFunction({ commit }) {
      commit("setTriggerFunction", true);
    },
    resetTriggerFunction({ commit }) {
      commit("setTriggerFunction", false);
    },
    triggerFunction1({ commit }) {
      commit("setTriggerFunction1", true);
    },
    resetTriggerFunction1({ commit }) {
      commit("setTriggerFunction1", false);
    },
    triggerFunction2({ commit }) {
      commit("setTriggerFunction2", true);
    },
    resetTriggerFunction2({ commit }) {
      commit("setTriggerFunction2", false);
    },
    triggerFunction3({ commit }) {
      commit("setTriggerFunction3", true);
    },
    resetTriggerFunction3({ commit }) {
      commit("setTriggerFunction3", false);
    },
    triggerFunction4({ commit }) {
      commit("setTriggerFunction4", true);
    },
    resetTriggerFunction4({ commit }) {
      commit("setTriggerFunction4", false);
    },
    triggerFunction5({ commit }) {
      commit("setTriggerFunction5", true);
    },
    resetTriggerFunction5({ commit }) {
      commit("setTriggerFunction5", false);
    },
    triggerFunction6({ commit }) {
      commit("setTriggerFunction6", true);
    },
    resetTriggerFunction6({ commit }) {
      commit("setTriggerFunction6", false);
    },
    triggerFunction7({ commit }) {
      commit("setTriggerFunction7", true);
    },
    resetTriggerFunction7({ commit }) {
      commit("setTriggerFunction7", false);
    },
    triggerFunction8({ commit }) {
      commit("setTriggerFunction8", true);
    },
    resetTriggerFunction8({ commit }) {
      commit("setTriggerFunction8", false);
    },
    triggerFunction9({ commit }) {
      commit("setTriggerFunction9", true);
    },
    resetTriggerFunction9({ commit }) {
      commit("setTriggerFunction9", false);
    },
    triggerFunction10({ commit }) {
      commit("setTriggerFunction10", true);
    },
    resetTriggerFunction10({ commit }) {
      commit("setTriggerFunction10", false);
    },
    setTrigger({ commit }, newValue) {
      commit("setTrigger", newValue);
    },
    setLang({ commit }, payload) {
      commit("changeLang", payload);
    },
  },
  modules: {
    layout,
    menu,
  },
});
